export const PublicRoute = ({children}) => {
    return children;
};
